import { render, staticRenderFns } from "./PreviewQuestions.vue?vue&type=template&id=70ccf913&"
import script from "./PreviewQuestions.vue?vue&type=script&lang=js&"
export * from "./PreviewQuestions.vue?vue&type=script&lang=js&"
import style0 from "./PreviewQuestions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports